import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hollySpringsConfig } from "./data";

export default function HollySpringsPage() {
  return <CityPageTemplate config={hollySpringsConfig} />;
}